import {
	useInfiniteQuery,
	type InfiniteData,
	type UseInfiniteQueryOptions,
} from '@tanstack/react-query';
import {
	getPeople,
	getPeopleEndpoint,
	type QueryError,
	type GetPeopleResult,
	type GetPeopleRequestOptions,
} from '../getPeople';
export * from '../getPeople';

export type GetPeopleResultInfiniteData = InfiniteData<GetPeopleResult>;

// page params are handled via the infinite query `pageParams`
export type GetPeopleQueryParams = Omit<
	GetPeopleRequestOptions,
	'startIndex' | 'stopIndex'
>;

export type GetPeopleQueryKey = [string, GetPeopleQueryParams];

export type GetPeopleQueryOptions = Omit<
	UseInfiniteQueryOptions<
		GetPeopleResult,
		QueryError,
		GetPeopleResult,
		GetPeopleResult,
		GetPeopleQueryKey
	>,
	'queryKey' | 'queryFn'
>;

export const GetPeopleReactQueryKey = getPeopleEndpoint;

/**
 * react-query wrapper for `getPeople`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryGetPeople = (
	queryKeyParams: GetPeopleQueryParams = {},
	options?: GetPeopleQueryOptions,
) =>
	useInfiniteQuery<
		GetPeopleResult,
		QueryError,
		GetPeopleResult,
		GetPeopleQueryKey
	>({
		queryKey: [getPeopleEndpoint, queryKeyParams],
		queryFn: ({queryKey, pageParam, signal}) =>
			getPeople({...queryKey[1], ...pageParam}, signal),
		...options,
	});

export default useReactQueryGetPeople;
